import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useMutation, useApolloClient } from "react-apollo";
import { Fieldset, Field, Control, Button } from "rbx";

import Section from "../Section";

import { CREATE_ROUTE_PRODUCT_MUTATION } from "../../graphql/Routes/RouteProducts.graphql";
import { SINGLE_PRODUCT_QUERY } from "../../graphql/Products/Products.graphql";
import { ourToast as toast } from "../../utils";

import RouteProductBillingForm from "./RouteProductBillingForm";
import RouteProductDispatcherForm from "./RouteProductDispatcherForm";

const DEFAULT_STATE = {
  LineNumber: "",
  ProductNoRecIdRef: "",
  ChargeMethodRecIdRef: "",
  Rate: "",
  TariffCodeRecIdRef: "",
  HazmatCode: "",
  UOMRecIdRef: "",
  Percentage: ""
};

const AddRouteProductForm = ({
  RouteRecIdRef,
  isAddingAsDispatcher = false,
  setModalOpen
}) => {
  const client = useApolloClient();

  const [createRouteProduct, { loading }] = useMutation(
    CREATE_ROUTE_PRODUCT_MUTATION,
    {
      refetchQueries: ["ALL_ROUTE_PRODUCTS_QUERY"]
    }
  );

  const [inputs, setInputs] = useState(DEFAULT_STATE);

  const handleChange = e => {
    e.persist();
    setInputs(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: ProductData } = await client.query({
          query: SINGLE_PRODUCT_QUERY,
          variables: {
            where: {
              RecId: parseInt(inputs.ProductNoRecIdRef)
            }
          }
        });
        if (ProductData && ProductData.Product) {
          setInputs(prev => ({
            ...prev,
            Rate: ProductData.Product.Price,
            HazmatCode: ProductData.Product.HazmatCode,
            Description: ProductData.Product.Description,
            ProductCatgRecIdRef: ProductData.Product.ProductCatgRecIdRef,
            Percentage: ProductData.Product.Percentage,
            UOMRecIdRef: ProductData.Product.UOMRecIdRef
          }));
        }
      } catch (err) {
        toast.error("Error getting Product.");
      }
    };
    if (inputs.ProductNoRecIdRef) {
      fetchData();
    }
  }, [client, inputs.ProductNoRecIdRef]);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await createRouteProduct({
        variables: {
          data: {
            RouteRecIdRef,
            ProductNoRecIdRef: parseInt(inputs.ProductNoRecIdRef),
            Rate: inputs.Rate ? parseFloat(inputs.Rate) : null,
            UOMRecIdRef: inputs.UOMRecIdRef
              ? parseInt(inputs.UOMRecIdRef)
              : null,
            InternalComm: inputs.InternalComm,
            ExternalComm: inputs.ExternalComm,
            Percentage: parseFloat(inputs.Percentage),
            ProductCatgRecIdRef: parseInt(inputs.ProductCatgRecIdRef),
            ProdDescription: inputs.Description
          }
        }
      });
      toast.success("Route Product added successfully.");
      setModalOpen();
    } catch (err) {
      toast.error("Error adding Route Product.");
    }
  };
  return (
    <Section title="Add Route Product">
      <form id="add-route-product" method="POST" onSubmit={handleSubmit}>
        <Fieldset aria-busy={loading}>
          {isAddingAsDispatcher ? (
            <RouteProductDispatcherForm
              inputs={inputs}
              onChange={handleChange}
            />
          ) : (
            <RouteProductBillingForm
              adding
              inputs={inputs}
              onChange={handleChange}
            />
          )}
          <hr />
          <Field kind="group">
            <Control>
              <Button color="primary" type="submit">
                Submit
              </Button>
            </Control>
            <Control>
              <Button type="button" onClick={() => setModalOpen(false)}>
                Cancel
              </Button>
            </Control>
          </Field>
        </Fieldset>
      </form>
    </Section>
  );
};

AddRouteProductForm.propTypes = {
  setModalOpen: PropTypes.func,
  RouteRecIdRef: PropTypes.number,
  isAddingAsDispatcher: PropTypes.bool
};

export default AddRouteProductForm;
